import ResponsiveLoading from './ResponsiveLoading';

export default ResponsiveLoading;
